import { LogIn, UserPlus } from "lucide-react";
import { useAuthModal } from "@/contexts/AuthModalContext";
import { SIGNUPS_ENABLED } from "@/config/featureFlags";

interface NavAuthButtonsProps {
  loginLabel: string;
  signupLabel: string;
}

export function NavAuthButtons({ loginLabel, signupLabel }: NavAuthButtonsProps) {
  const { openAuthModal } = useAuthModal();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => openAuthModal("login")}
        className="px-4 py-2 rounded-xl font-medium text-sm text-foreground border border-muted-foreground/50 hover:border-foreground hover:bg-secondary/30 transition-all flex items-center gap-1.5"
      >
        <LogIn className="w-4 h-4" />
        {loginLabel}
      </button>
      {/* Signup hidden during the wind-down — login only. */}
      {SIGNUPS_ENABLED && (
        <button
          onClick={() => openAuthModal("signup")}
          className="px-4 py-2 rounded-xl font-medium text-sm text-primary-foreground bg-primary hover:bg-primary/90 transition-all flex items-center gap-1.5"
        >
          <UserPlus className="w-4 h-4" />
          {signupLabel}
        </button>
      )}
    </div>
  );
}
